import CONFIG from "../../config";
import customAxios from "./axios";

export const getAllAffiliateAgents = (page,filterState) =>
  customAxios.get(`${CONFIG.apiURL}/AffiliateAgent/GetAll?page=${page}&Email=${filterState.email}&MobileNumber=${filterState.mobileNumber}&EmiratesId=${filterState.emiratesId}`);

export const getAllAffiliateAgentById = (id) =>
  customAxios.get(`${CONFIG.apiURL}/AffiliateAgent/Get?id=${id}`);

export const createAffiliateAgent = (payload) =>
  customAxios.post(`${CONFIG.apiURL}/AffiliateAgent/Create`, payload);

export const updateAffiliateAgent = (id, payload) =>
  customAxios.put(`${CONFIG.apiURL}/AffiliateAgent/Update?id=${id}`, payload);
